import { TrustpilotWidget } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { TEMPLATE_IDS } from '@spotahome/ui-library/src/tenant/components/TrustpilotWidget/TrustpilotWidget';

import Section from './Section';

import './Testimonials.scss';

const Testimonials = () => {
  return (
    <Section className="hiw-testimonials">
      <h2 className="hiw-testimonials__title">
        {trans('how_it_works.testimonials.title')}
      </h2>
      <TrustpilotWidget
        className="hiw-testimonials__widget"
        template={TEMPLATE_IDS.SLIDER}
        width="100%"
        height={160}
      />
    </Section>
  );
};

export default Testimonials;
